import { getAuth } from 'firebase/auth';
import config from 'config';
import axios from 'axios';

const auth = getAuth();
const apiUrl = config.apiUrl;

export const createMarketTrendsAnalysis = async (input, type) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  try {
    const token = await user.getIdToken();

    const response = await axios.post(`${apiUrl}/lpcompare/create_market_trends_analysis/`, 
      type === 'url' ? { url: input } : { industry: input }, 
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
      }
    );

    if (response.status !== 200) {
      throw new Error('Failed to create market trends analysis.');
    }

    // Start polling with the task_id
    return pollMarketTrendsAnalysis(response.data.task_id);
  } catch (error) {
    console.error('Error creating market trends analysis:', error);
    throw error;
  }
};

const pollMarketTrendsAnalysis = async (taskId) => {
  let continuePolling = true;
  let retryCount = 0;
  const maxRetries = 40;
  const pollingInterval = 2000; // 2 seconds

  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  while (continuePolling && retryCount < maxRetries) {
    try {
      const token = await user.getIdToken();
      const response = await axios.get(
        `${apiUrl}/lpcompare/check_market_trends_analysis/${taskId}/`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',
        }
      );

      if (!response.data.processing_status) {
        // Task completed
        return {
          market_trends: response.data.market_trends || {},
          overview_result: response.data.overview_result || '',
          industry_name: response.data.industry_name || '',
          url: response.data.url || '',
          success_status: response.data.success_status,
          error: response.data.error
        };
      }

      // Wait before next polling attempt
      await new Promise(resolve => setTimeout(resolve, pollingInterval));
      retryCount++;
    } catch (error) {
      console.error('Error polling market trends analysis:', error);
      throw error;
    }
  }

  throw new Error('Polling timeout: Market trends analysis took too long');
}; 